module.exports = __webpack_public_path__ + "assets/img/solutions1.73236e63.png";